export default __webpack_public_path__ + "static/media/nutrionist@3x.e8815330.png";